import { TimezoneUtils } from '../../utils/timezoneUtils';

export const formatTime = (ts) => {
  if (!ts) return '';
  const result = TimezoneUtils.formatDateTime(ts, 'HH:mm');
  return result === '-' ? '' : result;
};

export const formatDateTime = (ts) => {
  if (!ts) return '';
  const result = TimezoneUtils.formatDateTime(ts, 'YYYY-MM-DD HH:mm');
  return result === '-' ? '' : result;
};

export const getInitial = (text) => {
  if (!text) return '?';
  const trimmed = String(text).trim();
  if (!trimmed) return '?';
  return trimmed.charAt(0).toUpperCase();
};

export const isImageType = (mt) =>
  mt && (mt.toLowerCase() === 'image' || mt.toLowerCase() === 'image_batch');

export const isVideoType = (mt) =>
  mt && (mt.toLowerCase() === 'video' || mt.toLowerCase() === 'video_batch');

export const isMixedType = (mt) =>
  mt && mt.toLowerCase() === 'mixed_media_batch';

export const isAudioType = (mt) =>
  mt && mt.toLowerCase() === 'audio';

/**
 * 合併 DB 歷史訊息與本地 intervention 訊息，依時間排序。
 */
export const buildCombinedMessages = (activeSession, interventionMessages) => {
  if (!activeSession) return [];
  const history = Array.isArray(activeSession.messages) ? activeSession.messages : [];
  const local = interventionMessages[activeSession.id] || [];
  const merged = [
    ...history.map((m, idx) => ({
      key: `h-${idx}`,
      role: m.role,
      content: m.content,
      at: m.at,
      messageType: m.messageType,
      mediaUrl: m.mediaUrl,
      mediaUrls: m.mediaUrls,
      videoUrls: m.videoUrls,
      mediaMimeType: m.mediaMimeType,
      caption: m.caption,
      sttText: m.sttText,
      intervention: false
    })),
    ...local
  ];
  return merged.sort((a, b) => {
    const ta = a.at ? new Date(a.at).getTime() : 0;
    const tb = b.at ? new Date(b.at).getTime() : 0;
    return ta - tb;
  });
};
